import React from "react";


const Page5 = () => {
  const items = [
    {
      icon: "./img/module1/page5.1.svg",
      title: "Mudança Emergencial",
      text: "Mudança aplicada imediatamente para proteger a segurança, o meio ambiente, a qualidade ou o produto, devendo ser restabelecida ou formalizada no primeiro dia útil."
    },
    {
      icon: "./img/module1/page5.2.svg",
      title: "Mudança Permanente",
      text: "É a mudança que não será revertida ao status original. Após sua implementação, a nova condição passa a fazer parte definitiva do processo, sistema ou instalação."
    },
    {
      icon: "./img/module1/page5.3.svg",
      title: "Mudança Temporária",
      text: "Mudança planejada, de caráter não permanente, que inclui um plano para retorno ao status original. Antes de ser realizada, é necessário avaliar os riscos envolvidos."
    },
    {
      icon: "./img/module1/page5.4.svg",
      title: 'Like for Like / “In Kind” change (Igual por igual)',
      text: "Substituição por item idêntico sem qualquer alteração ou impacto no sistema, com a mesma função, especificação e desempenho. Por não alterar o risco, não é considerada uma mudança e não requer MOC."
    }
  ];

  return (
    <div className="page-container" style={{background: "#ffffff"}}>
      <div className="content">
        
        <h1>Tipos de Mudanças</h1>

        <p className="description">
          Quando falamos em mudanças no contexto industrial, é importante lembrar:
          nem todas têm o mesmo impacto ou a mesma duração. É por isso que, no MOC,
          as mudanças podem ser entendidas sob dois aspectos: o tipo de mudança e a
          forma como ela se manifesta. <strong>Veja, a seguir, os principais tipos de mudança:</strong>
          
        </p>

        <div className="grid">
          {items.map((item, index) => (
            <div key={index} className="card">
              {/* <div className="icon">{item.icon}</div> */}
              <img src={item.icon} alt="" />
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .page-container {
          width: 100%;
          display: flex;
          justify-content: center;
          background: #f8fafc;
        }

        .content {
          max-width: 1200px;
          padding: 80px 20px;
          text-align: center;
        }

        h1 {
          font-size: 42px;
          color: #334155;
          margin-bottom: 20px;
        }

        .description {
          max-width: 900px;
          margin: 0 auto 60px auto;
          color: #475569;
          line-height: 1.6;
          font-size: 16px;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 40px;
        }

        .card {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          border: none;
          cursor: auto;
        }

        .icon {
          width: 90px;
          height: 90px;
          background: #e2e8f0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 32px;
          color: #4f7cac;
          margin-bottom: 20px;
        }

        h3 {
          color: #4592C5;
          font-size: 18px;
          margin-bottom: 10px;
          margin-top: 15px;
        }

        .card p {
          font-size: 14px;
          color: #475569;
          line-height: 1.5;
          max-width: 250px;
          text-align: left;
        }

        /* RESPONSIVO */
        @media (max-width: 1024px) {
          .grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
          }
        }

        @media (max-width: 768px) {
          h1 {
            font-size: 28px;
          }

          .description {
            font-size: 14px;
            margin-bottom: 40px;
          }

          .grid {
            grid-template-columns: 1fr;
            gap: 25px;
          }

          .icon {
            width: 70px;
            height: 70px;
            font-size: 24px;
          }
        }
      `}</style>
    </div>
  );
};

export default Page5;